import React, { useState } from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import IconInfo from '../../../assets/icons/icon-info-blue.svg'
import { resolveUrlForArticles } from './utils/urlUtils'
import { interpolate, getCurrentUnixTimestamp } from './utils/displayUtils'
import { REQUIREMENT } from './utils/constants/levels'
import { ADDITIONAL_REQUIREMENTS } from './utils/constants/additionalRequirements'
import { EVENTS_URLS } from './utils/constants/externalUrls'
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  AdditionalRequirementContent,
  AdditionalRequirementActions,
  AdditionalRequirementTextLink,
  TextButton,
  ActionButton,
  ActionButtonText
} from './Styles/ProgressTracker.styles'

const AdditionalRequirementsList = ({ additionalRequirements }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const hasPATRequirement = additionalRequirements.some(
    req => (req.key) === REQUIREMENT.PLAYING_ABILITY_TEST
  )
  const requirementsCount = hasPATRequirement ? 2 : 1
  
  const unixTimestamp = getCurrentUnixTimestamp()

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {requirementsCount}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific level but must be completed before applying for PGA of America Membership.
          </AdditionalRequirementsDescription>

          {/* PAT Requirement - conditionally shown in list */}
          {hasPATRequirement && (
            <AdditionalRequirementCard hasWarning>
              <AdditionalRequirementHeader>
                <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
                <AdditionalRequirementTitle>
                  {ADDITIONAL_REQUIREMENTS.PAT.title}
                </AdditionalRequirementTitle>
              </AdditionalRequirementHeader>
              <AdditionalRequirementContent>
                <AdditionalRequirementDescription>
                  {ADDITIONAL_REQUIREMENTS.PAT.description}
                </AdditionalRequirementDescription>
                <AdditionalRequirementActions>
                  <ActionButton 
                    as="a" 
                    href={interpolate(EVENTS_URLS.PAT_SEARCH, { unixTimestamp })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ActionButtonText>{ADDITIONAL_REQUIREMENTS.PAT.primaryLinkText}</ActionButtonText>
                  </ActionButton>
                  <AdditionalRequirementTextLink 
                    as="a" 
                    href={resolveUrlForArticles(ADDITIONAL_REQUIREMENTS.PAT.secondaryLinkUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ADDITIONAL_REQUIREMENTS.PAT.secondaryLinkText}
                  </AdditionalRequirementTextLink>
                </AdditionalRequirementActions>
              </AdditionalRequirementContent>
            </AdditionalRequirementCard>
          )}

          {/* Work Experience Credits - always shown in list */}
          <AdditionalRequirementCard>
            <AdditionalRequirementHeader>
              <AdditionalRequirementIcon src={IconInfo} />
              <AdditionalRequirementTitle>
                {ADDITIONAL_REQUIREMENTS.WORK_EXPERIENCE_CREDITS.title}
              </AdditionalRequirementTitle>
            </AdditionalRequirementHeader>
            <AdditionalRequirementContent>
              <AdditionalRequirementDescription>
                {ADDITIONAL_REQUIREMENTS.WORK_EXPERIENCE_CREDITS.description}
              </AdditionalRequirementDescription>
              <AdditionalRequirementActions>
                <AdditionalRequirementTextLink 
                  as="a" 
                  href={resolveUrlForArticles(ADDITIONAL_REQUIREMENTS.WORK_EXPERIENCE_CREDITS.linkUrl)} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {ADDITIONAL_REQUIREMENTS.WORK_EXPERIENCE_CREDITS.linkText}
                </AdditionalRequirementTextLink>
              </AdditionalRequirementActions>
            </AdditionalRequirementContent>
          </AdditionalRequirementCard>
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
